import { Button, GetProps, Input, message, Modal, Typography } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './verifyOtp.css';
import { useDispatch, useSelector } from 'react-redux';
import { VerifyOtpApi } from '../../../../redux/features/auth/VerifyOTP';
import { ForgotPasswordApi } from '../../../../redux/features/auth/ForgotPassword';
import { ArrowRightOutlined } from '@ant-design/icons';
import { FaWindowClose } from 'react-icons/fa';
import { useLogType } from '../../../../context/LogTypeContext';
import { InfluencerVerifyOtpApi, resetInfluencerVerifyOtp } from '../../../../redux/features/auth/InfluencerVerifyOTP';

interface Props {
	userName: any;
	trigger: any;
	disMdl: any;
	accessToken: any;
	resendOtpToggle?: any;
}
type OTPProps = GetProps<typeof Input.OTP>;

const VerifyOTP = ({ userName, trigger, disMdl, accessToken,resendOtpToggle }: Props) => {

	const [openVerifyMdl, setOpenVerifyMdl] = useState<boolean>(true),
		[otp, setOtp] = useState<string>(''),
		{ Title } = Typography,
		dispatch = useDispatch(),
			 navigate = useNavigate(),
		{ forgotPassRes } = useSelector((state: any) => state.forgotPassword),

		// [countdown, setCountdown] = useState<number>(forgotPassRes?.data?.exp),
		maskedPhoneNumber = forgotPassRes?.data?.contactNumber ? `******${forgotPassRes?.data?.contactNumber.slice(-4)}` : '';

		let expTime :any = forgotPassRes?.data?.exp ?? 4
		const [countdown, setCountdown] = useState<number>(expTime)

		

		
	const onFinishOTPVerify = (values: any) => {
		if (!disMdl){
			dispatch(
				VerifyOtpApi({
					headers: {
						CustomToken: accessToken,
						otp: otp
					}
				})
			);
		}else{
			dispatch(
				InfluencerVerifyOtpApi({
					headers: {
						CustomToken: accessToken,
						otp: otp
					}
				})
			);
		}
	};

	useEffect(() => {
		if (forgotPassRes?.data?.exp) {
			 setCountdown(forgotPassRes.data.exp);
		}
  }, [forgotPassRes]);
  

	
	const { logtype, setLogtype,isResendOtp, setIsResendOtp, } = useLogType();

	

	useEffect(() => {}, [disMdl]);

	const onInput: OTPProps['onInput'] = (value) => {
		setOtp(value.join(''));
	};

	const sharedProps: OTPProps = {
		onInput
	};

	const handleCancel = () => {
		trigger(false);
		setOpenVerifyMdl(false);
	};


	const onFinishResendOtp = () => {
		const formData = new URLSearchParams();
		if (disMdl) {
			formData.append('PhoneNumber', userName);
			resendOtpToggle()
		}else{
			formData.append('Username', userName);
			resendOtpToggle()
		}

		
		formData.append('UserType', logtype);
		// Call API without token
		dispatch(ForgotPasswordApi({ input: formData }));
		setCountdown(forgotPassRes?.data?.exp);
	};

	useEffect(() => {
		// Countdown logic
		let timer: NodeJS.Timeout | null = null;
		if (countdown > 0) {
			timer = setInterval(() => {
				setCountdown((prev) => prev - 1);
			}, 1000);
		} else if (timer) {
			clearInterval(timer);
		}
		return () => {
			if (timer) clearInterval(timer);
		};
	}, [countdown]);

	const formatCountdown = (seconds: number) => {
		const minutes = Math.floor(seconds / 60);
		const secs = seconds % 60;
		return `${minutes}:${secs < 10 ? `0${secs}` : secs}`;
	};

	// 24 Hrs - Save data
	const setWithExpiryEOD = (key: any, value: any) => {
		const now = new Date();
		const endOfDay = new Date(now);
		endOfDay.setHours(23, 59, 59, 999); // Set to the last millisecond of the day
		const expiryTime = endOfDay.getTime();
		// const expiryTime = now.getTime() + 10 * 60 * 1000;
		const item = { value, expiryTime };
		// const item = { value, expiryTime };
		localStorage.setItem(key, JSON.stringify(item));
	};

	// 1 Minute - Save data
	// const setWithExpiryEOD = (key: any, value: any) => {
	// 	const now = new Date();
	// 	const expiryTime = now.getTime() + 1 * 60 * 1000; // 1 minute = 60,000 ms
	// 	const item = { value, expiryTime };
	// 	localStorage.setItem(key, JSON.stringify(item));
	// };

	const { verifyOtpRes, verifyOtpLoad } = useSelector((state: any) => state?.influencerVerifyOtp||{});
	const {isVerifyModalVisible, setIsVerifyModalVisible} = useLogType();

	useEffect(() => {
		if (disMdl) {
			// switch (verifyOtpRes?.DATA?.[0]?.STATUSCODE) {
			switch (verifyOtpRes?.statusCode) {
				case 200:
					setIsVerifyModalVisible(false);
					setWithExpiryEOD("authUser", verifyOtpRes?.data?.DATA?.[0])
					navigate('/home');
					dispatch(resetInfluencerVerifyOtp()); 
					break;
				case 400:
					message.warning(verifyOtpRes?.message);
					dispatch(resetInfluencerVerifyOtp());
					break;
				case 500:
					message.error(verifyOtpRes.message);
					dispatch(resetInfluencerVerifyOtp());
					break;
				default:
					break;
			}
		}
	}, [verifyOtpRes, verifyOtpLoad]);

	return (
		<Modal
			className="gx-p-0"
			width={325}
			closable={false}
			maskClosable={false}
			open={openVerifyMdl}
			footer={false}
			style={{
				background: 'transparent',
				boxShadow: 'none'
			}}
		>
			<div style={{ textAlign: 'center', position: 'relative' }}>
				<span title="Close" onClick={() => handleCancel()} className="closeIcon">
					<FaWindowClose />
				</span>
				<span
					className="gx-link"
					style={{
						alignItems: 'center',
						fontWeight: 'bold',
						fontSize: '18px',
						color:'black'
					}}
				>
					OTP Verification
				</span>
				<img alt="" src="/assets/images/verifyOtp.png" style={{ marginBottom: '10px', width: '150px' }} />
			</div>

			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center'
				}}
			>
				<Title
					level={5}
					style={{
						textAlign: 'center',
						marginBottom: '10px',
						color: '#6c757d'
					}}
				>
					<p className="subLine">
						Enter the 6-digit code we sent to your phone number <span style={{ fontWeight: 'bold' }}>{maskedPhoneNumber}</span> to continue
					</p>
				</Title>
				<Input.OTP
					formatter={(str) => str.toUpperCase()}
					{...sharedProps}
					style={{
						width: '80%',
						textAlign: 'center'
					}}
				/>
				{/* Countdown Timer */}
				<p style={{ marginTop: '10px', fontSize: '12px', color: countdown > 0 ? '#6c757d' : 'red' }}>
					{countdown > 0 ? `OTP Expire In: ${formatCountdown(countdown)}` : 'OTP expired. Please resend.'}
				</p>
				<Button
					size="small"
					className="verify-custom-button"
					// type="primary"
					htmlType="submit"
					disabled={otp.length !== 6}
					onClick={onFinishOTPVerify}
					// style={{
					// 	borderRadius: '5px',
					// 	marginBottom: '10px',
					// 	width: '70%',
					// 	marginRight: '0'
					// }}
				>
					Verify and Proceed <ArrowRightOutlined />
				</Button>
				<p className="subLine">
					Didn't receive code?{' '}
					<Link
						to=""
						onClick={() => {
							onFinishResendOtp();
							setIsResendOtp(true);
						}}
					>
						Resend
					</Link>
				</p>
			</div>
		</Modal>
	);
};

export default VerifyOTP;
